"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogBrowser = void 0;
var datadog_browser_1 = require("./datadog-browser");
Object.defineProperty(exports, "datadogBrowser", { enumerable: true, get: function () { return datadog_browser_1.datadogBrowser; } });
//# sourceMappingURL=index.js.map